<template>
    <vx-prompt
        v-if="isShown"
        :title="title"
        :active.sync="isShown"
        prevent-close-on-accept
        persistent
        accept-text="Submit"
        @cancel="close"
        @accept="submitReport"
    >
        <vx-input
            icon="icon-hash"
            name="Type"
            class="w-full"
            label="Type"
            disabled
            v-model="status"
        />
        <vx-input
            icon="icon-info"
            name="Description"
            class="w-full"
            label="Description"
            disabled
            v-model="message"
        />
        <vx-textarea
            name="What Steps Did You Take?"
            class="w-full"
            label="Comments"
            size="normal"
            icon="icon-message-square"
            v-model="comments"
            style="height: 200px"
        />
    </vx-prompt>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
    name: 'bug-report-popup',
    props: {},
    data() {
        return {
            comments: ''
        }
    },
    computed: {
        ...mapGetters({
            details: 'bugs/payload',
            showPopup: 'bugs/showPopup'
        }),
        isShown: {
            get() {
                return this.showPopup
            },
            set(v) {
                if (!v) {
                    this.close()
                }
            }
        },
        title() {
            return `Report For Error: ${this.status}`
        },
        status() {
            return `${this.response.status} - ${this.response.statusText}`
        },
        statusText() {
            return this.response.statusText
        },
        message() {
            return this.responseBody.Message
        },
        request() {
            if (!this.details.error.config) {
                return {
                    baseURL: '',
                    url: window.location,
                    method: 'Not Applicable',
                    data: 'Not Applicable'
                }
            }
            return this.details.error.config
        },
        response() {
            if (!this.details.error.response) {
                return {
                    status: 0,
                    statusText: 'Front End Error',
                    data: {
                        Message: 'Front End Error',
                        ExceptionType: 'Not Applicable',
                        StackTrace: 'Not Applicable'
                    }
                }
            }
            return this.details.error.response
        },
        responseBody() {
            return this.response.data
        },
        route() {
            var route = this.details.route
            return {
                fullPath: route.fullPath,
                params: route.params,
                query: route.query,
                meta: route.meta
            }
        },
        requestUrl() {
            return `${this.request.baseURL}${this.request.url}`
        }
    },
    methods: {
        close() {
            this.$store.commit('bugs/CLOSE_REPORT')
        },
        async submitReport() {
            try {
                this.loading = true
                var packet = {
                    errorCode: this.response.status,
                    message: this.message,
                    exceptionType: this.responseBody.ExceptionType,
                    stackTrace: this.responseBody.StackTrace,
                    comments: this.comments,
                    route: JSON.stringify(this.route),
                    url: this.requestUrl,
                    method: this.request.method,
                    data: this.request.data,
                    binaryImage: this.details.binaryImage,
                    appStackTrace: this.details.stackTrace
                }

                await this.$store.dispatch('bugs/submit', packet)
                this.notifySuccess(
                    'Bug Successfully Reported',
                    'Successfully reported the issue to devrequests@compnow.com.au',
                    3000
                )
                this.close()
            } catch (err) {
                this.notifyError(
                    'Uh oh...',
                    'There was a bug in your bug report... You should probably email someone.<br>' +
                        'Maybe Try: <a href="mailto:devrequests@compnow.com.au">devrequests@compnow.com.au</a><br><br>' +
                        `Message: ${err}`
                )
            } finally {
                this.loading = false
            }
        }
    }
}
</script>

<style></style>
